import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { environment } from 'src/app/config/environments/environment';

import { PageDto } from '../models/dto/arrival/page.dto';
import { ReceivedResourcesDto } from '../models/dto/count-users.dto';
import { OccasionEligibleUserDto } from '../models/dto/occasion-eligible-user.dto';
import { OccasionUsersParamsDto } from '../models/dto/occasion-users-params.dto';

@Injectable({
  providedIn: 'root',
})
export class OccasionUsersService {
  private readonly path = 'occasion-users';
  private readonly summaryPath = 'summary';

  constructor(private http: HttpClient) {}

  public getSummary(
    idOccasion: string
  ): Promise<ReceivedResourcesDto> {
    return this.http
      .get<ReceivedResourcesDto>(
        `${environment.api.baseUrl}/${this.path}/${idOccasion}/${this.summaryPath}`
      )
      .toPromise();
  }

  public getAll(
    idOccasion: string,
    params?: OccasionUsersParamsDto
  ): Observable<PageDto<OccasionEligibleUserDto>> {
    const url = `${environment.api.baseUrl}/${this.path}/${idOccasion}`;
    const response = this.http.get<PageDto<OccasionEligibleUserDto>>(url, {
      params: _.omitBy(params, _.isNil),
    });
    return response;
  }
}
